<template>

  <div>
    <div class="window-header">
      <h3 class="title">Dar de alta una nueva clabe</h3>
      <button
        class="button-close"
        @click="$modal.hide('add-new-clabe')">×</button>
    </div>
    <div class="modal-content" v-if="!processHasFinished">
      <form @submit.prevent="submit" novalidate>
        <fieldset>
          <div class="row row-responsive">
            <div class="column column-sm-50">
              <label for="clabe">No. de clabe interbancaria:</label>
            </div>
            <div class="column column-sm-50">
              <input
                type="text"
                name="clabe"
                v-model.trim="$v.userInteraction.clabe.$model">
              <p class="error" v-if="errors">
                <span v-if="!$v.userInteraction.clabe.required">
                  La clabe es obligatoria
                </span>
                <span v-if="!$v.userInteraction.clabe.numeric">
                  La clabe debe ser numérica
                </span>
                <span v-if="!$v.userInteraction.clabe.minLength">
                  La clabe debe de 18 caracteres
                </span>
                <span v-if="!$v.userInteraction.clabe.maxLength">
                  La clabe debe de tener 18 caracteres
                </span>
              </p>
            </div>
          </div>
          <div class="modal-investment-buttons" v-if="!mfaIsVisible">
            <button
              class="button"
              @click.prevent="submit()">Confirmar alta de clabe
            </button>
            <button class="button button-outline" @click="$modal.hide('add-new-clabe')">Cancelar</button>
          </div>
        </fieldset>
      </form>
      <MFAHandler v-if="mfaIsVisible" v-on:tokenObtained="onClickedChild"></MFAHandler>
    </div>
    <div class="modal-content" v-if="processHasFinished">
      <div class="column column-xs-100 column-sm-80 column-offset-sm-10">
          <div class="box-fields row row-responsive -vertical-align">
            <div class="column column-sm-20">
              <CheckmarkOK></CheckmarkOK>
            </div>
            <div class="column column-sm-80 -centered-info">
              <h3 class="title-final">Tu clabe fue dada de alta con éxito.</h3>
              <button class="button" @click="reloadPage()">Cerrar</button>
            </div>
          </div>
        </div>
    </div>
  </div>

</template>

<script>

import CheckmarkOK from '@/components/CheckmarkOK'
import WaitingButton from '@/components/WaitingButton'
import MFAHandler from '@/components/MFAHandler'

import { required, numeric, minLength, maxLength }
  from 'vuelidate/lib/validators'
import httpRequestMixin from '@/mixins/httpRequestMixin'

export default {
  name: 'InvestorClabeAddNew',
  data () {
    return {
      errors: false,
      empty: false,
      mfaIsVisible: false,
      userInteraction: {
        clabe: ''
      },
      processHasFinished: false
    }
  },
  validations: {
    userInteraction: {
      clabe: {
        required,
        numeric,
        minLength: minLength(18),
        maxLength: maxLength(18)
      }
    }
  },
  mixins: [httpRequestMixin],
  components: {
    CheckmarkOK,
    WaitingButton,
    MFAHandler
  },
  methods: {
    submit: function () {
      this.empty = !this.$v.userInteraction.$anyDirty
      this.errors = this.$v.userInteraction.$anyError

      if (this.errors === false && this.empty === false) {
        this.mfaIsVisible = true
      }
    },
    onClickedChild: async function (token) {
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/investors/clabes/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        data: {
          clabe: this.userInteraction.clabe,
          token: token
        }
      }
      const response = await this.httpRequest(options)
      if (response) {
        switch (response.status) {
          case 201:
            this.mfaIsVisible = false
            this.processHasFinished = true
            break
          case 202:
            this.modalError(response.data.error, 'warning')
            break
          default:
            break
        }
      }
    },
    reloadPage () {
      window.location.reload()
    }
  }
}

</script>

<style lang="scss" scoped>

.message {
  padding: .3rem .4rem;
  background-color: $red;
  color: #fff;
  font-size: .75em;
  border-radius: 3px;
}

.label {
  font-weight: bold;
}

.error {
  color: $red;
}

.title-final {
  margin-bottom: .5rem;
  padding-bottom: .5rem;
  font-weight: 300;
  font-size: 1.1em;
}

</style>



// WEBPACK FOOTER //
// src/views/investorClabe/InvestorClabeAddNew.vue